<style>
	/* .btn {
		background-color: rgba(0,0,0,0.38);
		color: #fff;
		border-color: transparent;
		margin-bottom: 0;
		cursor: pointer;
  } */

	.btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0.7rem 1.4rem;
		border-radius: 0.25rem;
		box-sizing: border-box;
		text-transform: uppercase;
		font-weight: 400;
		color: #FFF;
		/* background-color: #3369ff; */
		background-color: rgba(0,0,0,0.38);
		box-shadow: 0 4px rgba(0,0,0,0.17);
		position: relative;
		border: none;
		cursor: pointer;
		flex-grow: 0;
	}

	.btn + .btn {
		margin-left: 1rem;
	}

	.btn:active,
	.btn:focus {
		outline: none;
	}

	.btn:active {
		box-shadow: 0 2px rgba(0,0,0,0.17);
		transform: translateY(2px);
	}

	.btn:disabled {
		opacity: 0.5;
	}

	.fullWidth {
		width: 100%;
		height: 3rem;
	}
</style>

<script>
  export let fullWidth = false;
</script>

<button class="btn" class:fullWidth={fullWidth} on:click><slot></slot></button>
